// File: src/components/AINetworkingAssistantWidget.jsx
// Description: Dashboard widget for AI Networking Assistant

import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  Chip,
  Stack,
  useTheme
} from '@mui/material';
import {
  SmartToy,
  Group,
  TrendingUp,
  Lightbulb
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const AINetworkingAssistantWidget = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate('/ai-networking-assistant');
  };

  return (
    <Card sx={{
      height: '100%',
      borderRadius: 3,
      boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: 'white',
      transition: 'all 0.3s ease-in-out',
      '&:hover': {
        transform: 'translateY(-8px)',
        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
      }
    }}>
      <CardContent sx={{ p: 3, height: '100%', display: 'flex', flexDirection: 'column' }}>
        {/* Header */}
        <Box display="flex" alignItems="center" mb={2}>
          <SmartToy sx={{ fontSize: 32, mr: 1.5 }} />
                      <Typography variant="h6" fontWeight="bold">
              AI Assistant
            </Typography>
        </Box>

        {/* Description */}
        <Typography variant="body2" sx={{ mb: 3, opacity: 0.9, flex: 1 }}>
          Get personalized career advice, professional strategies, and actionable insights 
          powered by AI to accelerate your professional growth.
        </Typography>

        {/* Features */}
        <Stack direction="row" flexWrap="wrap" gap={1} mb={3}>
          <Chip
            label="Career Advice"
            size="small"
            icon={<TrendingUp />}
            sx={{
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
              color: 'white',
              '& .MuiChip-icon': { color: 'white' }
            }}
          />
          <Chip
            label="Skill Development"
            size="small"
            icon={<Lightbulb />}
            sx={{
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
              color: 'white',
              '& .MuiChip-icon': { color: 'white' }
            }}
          />
          <Chip
            label="Professional Growth"
            size="small"
            icon={<Group />}
            sx={{
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
              color: 'white',
              '& .MuiChip-icon': { color: 'white' }
            }}
          />
        </Stack>

        {/* Action Button */}
        <Button
          fullWidth
          variant="contained"
          onClick={handleNavigate}
          sx={{
            backgroundColor: 'white',
            color: theme.palette.primary.main,
            fontWeight: 'bold',
              py: 1.5,
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.9)',
              transform: 'scale(1.02)',
            }
          }}
        >
                        Open AI Assistant
        </Button>
      </CardContent>
    </Card>
  );
};

export default AINetworkingAssistantWidget;
